export default __webpack_public_path__ + "static/media/vscode.1718d339.png";